import {
  type ISourceEntity,
  ISourceEntityTypes,
  SourceEntityMigrationType,
} from '@principle-theorem/practice-migrations/interfaces';
import { STAFFER_RESOURCE_TYPE } from '../../../destination/entities/staff';
import { SourceEntity } from '../../../source/source-entity';
import { TypeGuard } from '@principle-theorem/shared';
import { isBoolean, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { STAFF_DESTINATION_ENTITY } from '../../../exact/destination/entities/staff';

export const STAFFER_SOURCE_ENTITY: ISourceEntity = SourceEntity.init({
  metadata: {
    label: 'Staffer List',
    description: '',
    idPrefix: STAFFER_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

const STAFF_SOURCE_QUERY = `
SELECT
  employee_id::TEXT AS id,
  NULLIF(last_name, '') AS surname,
  NULLIF(first_name, '') AS first_name,
  NULLIF(license__, '') AS license_number,
  convert_to_boolean(inactive) AS is_inactive
FROM _employee_list_
WHERE employee_id IS NOT NULL
`;

export interface IPracticeWorksStaffer {
  id: string;
  surname?: string;
  firstName?: string;
  licenseNumber?: string;
  isInactive: boolean;
}

function isPracticeWorksStaffer(
  item: unknown,
  logError: boolean
): item is IPracticeWorksStaffer {
  return TypeGuard.interface<IPracticeWorksStaffer>(
    {
      id: isString,
      surname: TypeGuard.undefinedOr(isString),
      firstName: TypeGuard.undefinedOr(isString),
      licenseNumber: TypeGuard.undefinedOr(isString),
      isInactive: isBoolean,
    },
    logError
  )(item);
}

export type PracticeWorksStaffer = ISourceEntityTypes<IPracticeWorksStaffer>;

export class StafferSourceEntity extends BaseSourceEntity<PracticeWorksStaffer> {
  sourceEntity = STAFFER_SOURCE_ENTITY;
  entityResourceType = STAFFER_RESOURCE_TYPE;
  sourceQuery = STAFF_SOURCE_QUERY;
  verifySourceFn = isPracticeWorksStaffer;

  migrationDestinations = [STAFF_DESTINATION_ENTITY.metadata.key];

  translate(_staffer: IPracticeWorksStaffer): Record<symbol, unknown> {
    return {};
  }

  getSourceRecordId(data: IPracticeWorksStaffer): string {
    return data.id;
  }

  getSourceLabel(data: IPracticeWorksStaffer): string {
    const name = `${data.firstName} ${data.surname}`;
    return `${data.id} ${name}`;
  }
}
